<div [formGroup]="formGroup()">
    <p-select [options]="priority" optionLabel="name" placeholder="{{placeHolder()}}" styleClass="{{styleClass()}}"
        [formControl]="controlName()">
        <!-- <ng-template pTemplate="selectedItem" let-selectedOption>
            <div class="text-sm" *ngIf="selectedOption">{{selectedOption.name}}</div>
        </ng-template> -->
        <ng-template let-priority pTemplate="item">
            <div class="text-sm">{{priority.name}}</div>
        </ng-template>
    </p-select>
</div>